import {DataObjectId, Hub, HubProperties, MarketplaceApp} from 'yougile-model'
import {UUID} from 'yougile-util'
import {Sync} from './sync'

export class MarketplaceClient {
  public static apps: MarketplaceApp[] = []

  public static listEnabled(companyId: DataObjectId): MarketplaceApp[] {
    const box = Sync.get({companyId})
    const raw = box.get(companyId).properties[
      HubProperties.enabledApps
    ] as string
    if (raw) {
      const ids = new Set(JSON.parse(raw) as UUID[])
      return MarketplaceClient.apps.filter((app: MarketplaceApp) =>
        ids.has(app.id)
      )
    } else {
      return []
    }
  }

  public static enable(companyId: DataObjectId, appId: UUID): void {
    if (!appId || !companyId) {
      return
    }
    const box = Sync.get({companyId})
    const company = box.get(companyId) as Hub
    const raw = company.properties[HubProperties.enabledApps] as string
    if (raw) {
      const ids = new Set(JSON.parse(raw) as UUID[])
      ids.add(appId)
      company.properties[HubProperties.enabledApps] = JSON.stringify([...ids])
      company.commit()
    } else {
      company.properties[HubProperties.enabledApps] = JSON.stringify([appId])
      company.commit()
    }
  }

  public static disable(companyId: DataObjectId, appId: UUID): void {
    if (!appId || !companyId) {
      return
    }
    const box = Sync.get({companyId})
    const company = box.get(companyId) as Hub
    const raw = company.properties[HubProperties.enabledApps] as string
    if (raw) {
      const ids = new Set(JSON.parse(raw) as UUID[])
      if (ids.has(appId)) {
        ids.delete(appId)
        company.properties[HubProperties.enabledApps] = JSON.stringify([...ids])
        company.commit()
      }
    }
  }

  public static isEnabled(companyId: DataObjectId, appId: UUID): boolean {
    if (!appId || !companyId) {
      return false
    }
    const box = Sync.get({companyId})
    const raw = box.get(companyId).properties[
      HubProperties.enabledApps
    ] as string
    if (raw) {
      const ids = new Set(JSON.parse(raw) as UUID[])
      return ids.has(appId)
    } else {
      return false
    }
  }
}
